import React from 'react'
import { LoadLiftingComponent, LoadLiftingProps } from './LoadLiftingComponent'

const GoodsLift: React.FC<LoadLiftingProps> = (props) => (
  <LoadLiftingComponent {...props} booleanPropertyName='goodsLift' amountPropertyName='goodsLiftLoad' />
)
export default GoodsLift
